import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const gateApiUrl = process.env.REACT_APP_GATE_API_URL;

const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getApplicationListApi = async (id) => {
  try {
    const response = await axios.get(
      apiUrl + `get_applications?type=All&role_id=${id ?? ""}`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getWidgetListApi = async (applicationId, roleId) => {
  try {
    const response = await axios.get(
      apiUrl +
        `get_signage_permissions?application_id=${applicationId}&type=Internal&role_id=${
          roleId ?? ""
        }`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDeviceGroupListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `device?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getGroupListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `group?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getGroupApi = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}group/` + id, {
      headers: header,
    });
    return response; // ✅ make sure this line exists
  } catch (err) {
    console.error("Error saving device:", err.response?.data || err.message);
    return err.response; // ✅ rethrow the error so the caller knows
  }
};

export const createGroupApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `group`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateGroupApi = async (id, body) => {
  try {
    const response = await axios.put(`${apiUrl}group/` + id, body, {
      headers: header,
    });
    return response; // ✅ make sure this line exists
  } catch (err) {
    console.error("Error saving customer:", err.response?.data || err.message);
    return err.response; // ✅ rethrow the error so the caller knows
  }
};

export const getDeleteApi = async (deleteUrl) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
      data: { id: ids },
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const getInternalWidgetsApi = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}get_internal_widgets/` + id, {
      headers: header,
    });
    return response; // ✅ make sure this line exists
  } catch (err) {
    console.error("Error saving device:", err.response?.data || err.message);
    return err.response; // ✅ rethrow the error so the caller knows
  }
};
